import React, { useState, useEffect } from 'react';
import { Image, Text } from '@mantine/core';
import logo from '../assets/cb-logo.svg';
import AppleLogo from '../assets/app-store-logos/apple.png';
import GoogleLogo from '../assets/app-store-logos/google.png';
import HuaweiLogo from '../assets/app-store-logos/huawei.png';

function MobileAppOverlay() {
    const [isVisible, setIsVisible] = useState(false);
    const checkMobile = () => setIsVisible(window.innerWidth <= 640);

    useEffect(() => {
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);
    if (!isVisible) return null;

    return (
        <div
            className="fixed inset-0 z-50 flex flex-col items-center justify-center p-6"
            style={{
                background: 'linear-gradient(135deg, #ffffff 0%, #e5e7eb 100%)',
            }}
        >
            <Image
                src={logo}
                alt="Cashbuild Logo"
                width={180}
                className="mb-6 sm:mb-8"
            />

            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 text-center mb-2 px-4">
                Operations Manager
            </h2>
            <Text className="text-sm sm:text-base text-red-600 font-semibold mb-4 text-center px-4">
                This portal isn’t available on mobile. Please download the app
                or use a desktop or laptop.
            </Text>

            <div className="flex flex-col items-center space-y-4 sm:flex-row sm:space-y-0 sm:space-x-4">
                <a
                    href="https://apps.apple.com/us/app/cashbuild-operations-manager/id6480587686"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Download Cashbuild Operations Manager on the Apple App Store"
                >
                    <Image
                        src={AppleLogo}
                        width={130}
                        alt="Apple App Store badge"
                    />
                </a>
                <a
                    href="https://play.google.com/store/apps/details?id=com.cashbuild.operationsapp"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Get Cashbuild Operations Manager on Google Play"
                >
                    <Image
                        src={GoogleLogo}
                        width={130}
                        alt="Google Play badge"
                    />
                </a>
                <a
                    href="https://appgallery.huawei.com/app/C111427847"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Download Cashbuild Operations Manager from Huawei AppGallery"
                >
                    <Image
                        src={HuaweiLogo}
                        width={130}
                        alt="Huawei AppGallery badge"
                    />
                </a>
            </div>
        </div>
    );
}

export default MobileAppOverlay;
